import React from 'react';
import { AlertTriangle } from 'lucide-react';
import { isBlank } from './formatters';
import { AnimatedValue } from './AnimatedValue';
import './ReportsNative.css';

/**
 * Row of compact KPI stat cards (per financial-gl-detail.html summary
 * strip / revenue-night-audits.html stat strip).
 *
 * Props:
 *   stats   [{
 *     key?, label,                      // uppercase micro label
 *     value,                            // number or preformatted string/node
 *     format?,                          // applied when value is numeric
 *     currency?,
 *     suffix?,                          // small muted trailer ('/ 24')
 *     chip?: { tone, label, icon? },    // semantic chip next to the value
 *     sub?                              // muted caption line
 *   }]
 *   columns  grid column count (default stats.length)
 *   className, style
 */
export function StatStrip({ stats = [], columns, className, style }) {
  if (!stats.length) return null;
  const cols = columns || stats.length;
  return (
    <div
      className={`rn-stat-strip${className ? ` ${className}` : ''}`}
      style={{ gridTemplateColumns: `repeat(${cols}, 1fr)`, ...style }}
    >
      {stats.map((stat, i) => {
        const value =
          typeof stat.value === 'number' ? (
            <AnimatedValue value={stat.value} format={stat.format || 'number'} currency={stat.currency} />
          ) : isBlank(stat.value) ? (
            '—'
          ) : (
            stat.value
          );
        return (
          <div key={stat.key ?? i} className="rn-card rn-stat">
            <span className="rn-stat-lbl">{stat.label}</span>
            <span className="rn-stat-val">
              <span>
                {value}
                {stat.suffix && <small> {stat.suffix}</small>}
              </span>
              {stat.chip && (
                <span className={`rn-chip rn-chip-${stat.chip.tone || 'warning'}`}>
                  {stat.chip.icon !== undefined ? stat.chip.icon : stat.chip.tone !== 'success' && <AlertTriangle />}
                  {stat.chip.label}
                </span>
              )}
            </span>
            {stat.sub && <span className="rn-stat-sub">{stat.sub}</span>}
          </div>
        );
      })}
    </div>
  );
}

export default StatStrip;
